var _path;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgHomeFilled = function SvgHomeFilled(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 13.5002C7.5 11.6013 10.5 11.2849 10.5 13.5002V17.0002C10.5 17.5525 10.9477 18.0002 11.5 18.0002H17C17.5523 18.0002 18 17.5525 18 17.0002V8.22173C18 7.60455 17.7151 7.02194 17.2279 6.64303L10.2279 0.420807C9.50566 -0.14092 8.49434 -0.14092 7.77212 0.420808L0.772119 6.64303C0.284946 7.02194 0 7.60455 0 8.22173V17.0002C0 17.5525 0.447716 18.0002 1 18.0002H6.5C7.05228 18.0002 7.5 17.5525 7.5 17.0002V13.5002Z",
    fill: "#0B7375"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHomeFilled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home_filled.ff431064.svg";
export { ForwardRef as ReactComponent };